import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Applicants } from '../applicants/Applicants';
import { UrlSignature } from '../common/apiEndpoint';

@Injectable()
export class AcceptedApplicantsService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getAcceptedApplicantList(
    year: string,
    programmeId: string,
    programmeTypeId: string,
  ): Observable<Applicants[]> {
    const url =
      this.urlSignature.applicantTypeListUrl +
      year +
      '/' +
      programmeId +
      '/' +
      programmeTypeId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Applicants[]));
  }
}
